import React from "react";

import { Box, Divider, Tab, Tabs } from "@mui/material";

interface Props {
  currentTab: "prediction" | "allocation";
  setCurrentTab: (tab: "prediction" | "allocation") => void;
}

export const TableTabs: React.FC<Props> = ({ currentTab, setCurrentTab }) => {
  const handleChange = (event: React.SyntheticEvent, newValue: "prediction" | "allocation") => {
    setCurrentTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={currentTab}
          onChange={handleChange}
          sx={{
            borderBottom: "1px solid #DBE8F5",
            minHeight: "auto",

            ".MuiTabs-flexContainer": {
              gap: "16px",
              alignItems: "center"
            },

            ".MuiTabs-indicator": {
              bgcolor: "#071F35"
            },

            ".MuiTab-root": {
              padding: "2px 0 6px 0",
              minHeight: 24,
              minWidth: "auto",
              color: "#496682",
              "&.Mui-selected": {
                color: "#071F35"
              }
            }
          }}
        >
          <Tab value="prediction" label="Prediction Table" />
          <Divider orientation="vertical" sx={{ width: "1px", height: 18, borderColor: "#DBE8F5" }} />
          <Tab value="allocation" label="Allocation Output" />
        </Tabs>
      </Box>
    </Box>
  );
};
